import { defineComponent as _defineComponent } from 'vue'
import authService from '@/services/AuthService';
import { computed, onBeforeUnmount, onMounted } from 'vue';
import { useRoute } from 'vue-router/composables';
import paddleEventHandler, { checkoutStatus, stopCheckoutPolling } from '@/handlers/PaddleEventHandler';
import { isGuidesInLocation } from '@/helpers/appContext';
import { getProductsUrl, getSnaploreAppUrl } from '@/helpers/productsUrl';
import store from '@/store';
import logger from '@/other/Logger';
import router from '@/router';
import notificationService from '@/services/NotificationService';
import { Environments, initializePaddle } from '@paddle/paddle-js';
import { AxiosError } from 'axios';
import BackSnaploreButton from '@/components/pages/billing/PlansPage/BackSnaploreButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutPage',
  setup(__props) {

const { query } = useRoute();
const { transactionId } = query as { transactionId: string };

const isAuthorized = computed(() => authService.isAuthorized());

const initPaddle = () =>
  initializePaddle({
    environment: process.env.VUE_APP_PADDLE_ENV as Environments,
    token: process.env.VUE_APP_PADDLE_CLIENT_TOKEN,
    debug: process.env.VUE_APP_PADDLE_ENV === 'sandbox',
    checkout: {
      settings: {
        displayMode: 'inline',
        frameTarget: 'paddle-box',
        allowedPaymentMethods: ['google_pay', 'apple_pay', 'paypal', 'card'],
        frameInitialHeight: 1500,
        frameStyle:
          'max-width: 550px; width: 100%; height: 100%; min-width: 312px; background-color: #fff; border: none; border-radius: 10px;',
      },
    },
    eventCallback: (data) => {
      const handler = paddleEventHandler[data.name];
      if (handler) {
        handler(data, router);
      } else {
        logger.info(`No handler found for event: ${data.name}`);
      }
    },
  });

const openCheckout = async () => {
  try {
    const paddle = await initPaddle();

    paddle.Checkout.open({
      transactionId,
      settings: {
        allowLogout: false,
        allowDiscountRemoval: false,
        showAddDiscounts: false,
      },
    });
  } catch (e) {
    notificationService.error((e as AxiosError)?.message || 'Failed to initialize Paddle');
  }
};

const continueLabel = computed(() => (isGuidesInLocation() ? 'Continue to Guides' : 'Continue to Snaplore'));

const continueAfterPayment = () => {
  stopCheckoutPolling();
  const company = store.state.company;
  window.location.href = isGuidesInLocation()
    ? getProductsUrl()
    : getSnaploreAppUrl(company?.domain ? company.getDomainAddress() : null);
};

onMounted(() => {
  openCheckout();
});

onBeforeUnmount(() => {
  stopCheckoutPolling();
});

return { __sfc: true,query, transactionId, isAuthorized, initPaddle, openCheckout, continueLabel, continueAfterPayment, checkoutStatus, BackSnaploreButton }
}

})